import LandingPage from './LandingPage';

// The idea here is we could potentially export different LandingPages and be tied to routes and nested routes
export default { LandingPage };



// WEBPACK FOOTER //
// ./src/components/Pages/Account/index.js